import Modal, { BaseModalProps } from 'global/Modal/BaseModal';

import {
  Illustration,
  InfoText,
  InfoWrapper,
  ButtonContainer,
  ConfirmButton,
  LinkButton,
} from './styled';

interface ModalSuccessInfoProps extends BaseModalProps {
  src?: string;
  infoText?: string;
  onSuccess(): void;
  onBack(): void;
}

const ModalSuccessInfo = ({
  src = '/img/share-trade-delivered.svg',
  infoText = 'Order has been shared',
  ...props
}: ModalSuccessInfoProps) => (
  <Modal width={430} {...props}>
    <InfoWrapper>
      <Illustration src={src} />
      <InfoText>{infoText}</InfoText>
    </InfoWrapper>

    <ButtonContainer>
      <ConfirmButton
        type="primary"
        onClick={props.onSuccess}
        loading={props.confirmLoading}
        block
      >
        Done
      </ConfirmButton>

      <LinkButton onClick={props.onBack} block>
        Go to Chat List
      </LinkButton>
    </ButtonContainer>
  </Modal>
);

export default ModalSuccessInfo;
